import { render, staticRenderFns } from "./contract.view.vue?vue&type=template&id=66f798b8&scoped=true&"
import script from "./contract.view.vue?vue&type=script&lang=ts&"
export * from "./contract.view.vue?vue&type=script&lang=ts&"
import style0 from "./contract.view.vue?vue&type=style&index=0&id=66f798b8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f798b8",
  null
  
)

export default component.exports